// components/FileUpload.js
import React, { useState } from "react";
import Modal from "react-modal";
import fileService from "../services/fileService";

Modal.setAppElement("#root"); // Đặt modal vào root của React (index.html)

const FileUpload = () => {
  const [selectedFile, setSelectedFile] = useState(null);
  const [uploadStatus, setUploadStatus] = useState("");
  const [fileList, setFileList] = useState([]);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedFileId, setSelectedFileId] = useState(null);

  const handleFileChange = (e) => {
    setSelectedFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!selectedFile) {
      setUploadStatus("Vui lòng chọn một file trước khi upload.");
      return;
    }

    try {
      setUploadStatus("Đang tải lên...");
      const response = await fileService.uploadFile(selectedFile);
      if (response.error) {
        setUploadStatus(`Lỗi: ${response.error}`);
      } else {
        setUploadStatus("Upload thành công!");
        fetchFiles();
      }
    } catch (error) {
      setUploadStatus("Đã xảy ra lỗi khi tải lên.");
    }
  };

  const fetchFiles = async () => {
    const response = await fileService.getFiles();
    if (!response.error) {
      setFileList(response.data);
    } else {
      setUploadStatus(`Lỗi khi tải danh sách file: ${response.error}`);
    }
  };

  const openDeleteModal = (id) => {
    setSelectedFileId(id);
    setIsModalOpen(true);
  };

  const closeDeleteModal = () => {
    setIsModalOpen(false);
    setSelectedFileId(null);
  };

  const handleDelete = async () => {
    if (selectedFileId) {
      const response = await fileService.deleteFile(selectedFileId);
      if (!response.error) {
        setUploadStatus("Xóa file thành công.");
        fetchFiles();
      } else {
        setUploadStatus(`Lỗi khi xóa file: ${response.error}`);
      }
    }
    closeDeleteModal();
  };

  React.useEffect(() => {
    fetchFiles();
  }, []);

  return (
    <div style={{ padding: "20px" }}>
      <h2>Upload File</h2>

      <input type="file" onChange={handleFileChange} />
      <button onClick={handleUpload}>Upload</button>
      <p>{uploadStatus}</p>

      <h3>Danh sách file</h3>
      <ul>
        {fileList.map((file) => (
          <li key={file.id}>
            <a href={file.url} target="_blank" rel="noopener noreferrer">
              {file.filename}
            </a>
            <button onClick={() => openDeleteModal(file.id)}>Xóa</button>
          </li>
        ))}
      </ul>

      {/* Modal xác nhận xóa */}
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeDeleteModal}
        style={{
          content: {
            top: "50%",
            left: "50%",
            right: "auto",
            bottom: "auto",
            marginRight: "-50%",
            transform: "translate(-50%, -50%)",
          },
        }}
      >
        <h3>Xác nhận xóa</h3>
        <p>Bạn có chắc chắn muốn xóa file này?</p>
        <button onClick={handleDelete}>Xóa</button>
        <button onClick={closeDeleteModal}>Hủy</button>
      </Modal>
    </div>
  );
};

export default FileUpload;
